import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  closeTagLabel: {
    id: 'jutro-components.widgets.Tag.close',
    defaultMessage: 'Close'
  }
});